export default {
    '.png': 'image/png',
    '.jpeg': 'image/jpeg',
    '.jpg': 'image/jpg',
    '.svg': 'image/svg',
    '.gif': 'image/gif',
    '.pdf': 'application/pdf',
    '.doc': 'application/msword',
    '.docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    '.ppt': 'application/vnd.ms-powerpoint',
    '.pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    '.xls': 'application/vnd.ms-excel',
    '.xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    '.mp4': 'video/mp4',
    '.zip': 'application/x-zip-compressed',
    '.x_zip': 'application/zip',
    '.x_rar': 'application/x-rar',
    '.y_rar':'application/x-compressed',
    '.rar': 'application/octet-stream',
    '.7z': 'application/x-7z-compressed',


};
